<template>
  <v-card outlined>
    <v-card-title class="text_primary">
      {{ page_title }}

      <v-spacer></v-spacer>

      <v-btn color="#5087e6" class="white--text" @click="newSetting()"> 新增 </v-btn>
    </v-card-title>

    <v-divider></v-divider>
    <v-row class="mt-1 mb-1 pr-3">
      <v-col cols="12" lg="8" md="12" xs="12"> </v-col>
      <v-col cols="12" lg="4" md="12" xs="12">
        <v-card-text class="d-flex align-center justify-end pa-0">
          <p class="mb-0 pb-0 mr-3">顯示</p>
          <v-select
            v-model="selected_per_page"
            style="max-width: 7em"
            outlined
            return-object
            :items="per_page_items"
            item-value="value"
            item-text="name"
            hide-details
            dense
            @change="chagePerPage(selected_per_page)"
          >
          </v-select>
        </v-card-text>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-data-table hide-default-footer :headers="headers" :items="datas" :items-per-page="selected_per_page.value">
      <template #[`item.actions`]="{ item }">
        <v-btn class="text_default btn_default btn_default_bg_linear mr-3" outlined @click="edit(item)"> 檢視 </v-btn>
        <v-btn class="btn-danger white--text" outlined @click="del(item)"> 刪除 </v-btn>
      </template>
    </v-data-table>

    <div class="text-center mt-5">
      <Pagination v-if="page_setting.is_show" :setting="page_setting" />
    </div>
  </v-card>
</template>
<script>
import Pagination from '@/components/Utils/Pagination.vue'
import { apiGetSettings, apiDeleteSetting } from '@/api/iframe.js'
import { mapGetters } from 'vuex'
export default {
  name: 'TimerList',
  components: {
    Pagination,
  },
  data: function () {
    return {
      page_title: '倒數計時器',
      is_loading: false,
      datas: [],
      headers: [
        {
          text: '名稱',
          sortable: false,
          value: 'name',
        },
        {
          text: '',
          sortable: false,
          value: 'actions',
          align: 'right',
        },
      ],
      page_setting: {
        is_show: false,
        selected_page: 1,
        total_page: 10,
        total_visible: 5,
      },
      selected_per_page: {
        name: '48筆',
        value: 48,
      },
      per_page_items: [
        {
          name: '10筆',
          value: 10,
        },
        {
          name: '24筆',
          value: 24,
        },
        {
          name: '48筆',
          value: 48,
        },
        {
          name: '100筆',
          value: 100,
        },
      ],
    }
  },
  mounted: async function () {
    console.log('TimerList', this.memberQouta)
    this.initData()
  },
  methods: {
    initData: async function () {
      // 先抓網址上的頁碼，沒有預設就帶1
      let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
      let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : this.selected_per_page.value
      console.log('page_idx', page_idx)
      console.log('limit', limit)
      if (isNaN(limit)) {
        limit = 10
      }

      if (isNaN(page_idx)) {
        page_idx = 1
      }

      let data = await this.getSettings(page_idx, limit)
      console.log('回應', data)
      if (data === null) {
        return
      }

      this.page_setting = {
        is_show: true,
        selected_page: page_idx,
        total_page: data.totalPages,
      }
      this.datas = data.content
    },
    getSettings: async function (page_idx, limit) {
      let data = null
      let that = this
      data = await apiGetSettings(page_idx, limit, this.$route.params.container_id, this.$route.params.org_id)
        .then(function (resp) {
          console.log(resp.data.data)
          return resp.data.data
        })
        .catch(function (error) {
          if (error.includes('401') || error.includes('403')) {
            that.$root.vtoast.show({
              message: `無權限使用此功能，原因: ${error}`,
            })
            that.$router.push(`/${that.$route.params.org_id}/401`)
          } else {
            that.$root.vtoast.show({
              message: `取得設定檔失敗，原因: ${error}`,
            })
          }

          return null
        })
      return data
    },
    newSetting: function () {
      this.$router.push('new')
    },
    edit: function (item) {
      this.$router.push(item.id + '/edit')
    },
    del: async function (item) {
      let that = this
      let confirm_dialog = confirm(`確定要刪除 ${item.name} 嗎？`)
      if (!confirm_dialog) {
        return
      }
      apiDeleteSetting(item.id, this.$route.params.org_id)
        .then(function (resp) {
          console.log(resp)
          that.$root.vtoast.show({
            message: `${item.name} 刪除成功`,
          })
          that.initData()
        })
        .catch(function (error) {
          console.log(error)
          let msg = `${item.name} 刪除失敗，原因: ` + (error.response ? error.response : error)
          that.$root.vtoast.show({
            message: msg,
          })
        })
    },
    chagePerPage: function (selected_per_page) {
      let query = this.$route.query
      let tmp_query = { ...query, limit: selected_per_page.value, page: 1 }
      console.log(tmp_query)
      try {
        this.$router.push({ path: this.$route.path, query: tmp_query })
      } catch (err) {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
    },
  },
  computed: {
    ...mapGetters(['memberQouta']),
  },
}
</script>
<style scoped></style>
